import { createSlice } from '@reduxjs/toolkit';
import { getGeneratedMeetingUUID } from '../../utils/general';
import { resetStateBetweenCallObjects } from '../app/actions';
import { createSidePanelClient, getMeetingId, getMeetingSpace, getConferenceRecord } from './actions';
import { MEETING_UUID_DELIMITER } from '../../constants/google-meet';
const initialState = {
  client: null,
  meetingId: '',
  meet_sdk: '',
  origin: '',
  conferenceRecordId: '',
  canViewParticipants: null,
  meetingUri: '',
  meetingStartTime: null
};
const google = createSlice({
  name: 'google',
  initialState,
  reducers: {
    receiveMeetingId: (state, action) => {
      state.meetingId = action.payload;
    },
    setSdkParams: (state, action) => {
      state.meet_sdk = action.payload.meet_sdk;
      state.origin = action.payload.origin;
    },
    receiveMeetingContext: (state, action) => {
      state.canViewParticipants = action.payload.canViewParticipants;
      state.meetingId = action.payload.meetingID;
      // splitting the composite conferenceRecordId coming from in-meeting-experience-ui-components
      // to get the actual conferenceRecordId
      state.conferenceRecordId = action.payload.meetingUUID.split(MEETING_UUID_DELIMITER).pop() || '';
    }
  },
  extraReducers: builder => {
    builder.addCase(createSidePanelClient.fulfilled, (state, action) => {
      state.client = action.payload;
    });
    builder.addCase(getMeetingId.fulfilled, (state, action) => {
      state.meetingId = action.payload;
    });
    builder.addCase(getMeetingSpace.fulfilled, (state, action) => {
      var _action$payload, _action$payload2;
      const activeConference = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.activeConference;
      state.meetingUri = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.meetingUri;
      if (activeConference) {
        state.conferenceRecordId = activeConference.conferenceRecord;
        state.canViewParticipants = true;
      } else {
        state.conferenceRecordId = getGeneratedMeetingUUID(state.meetingId);
        state.canViewParticipants = false;
      }
    });
    builder.addCase(getConferenceRecord.fulfilled, (state, action) => {
      var _action$payload3;
      if ((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.startTime) {
        state.meetingStartTime = action.payload.startTime;
      }
    });
    builder.addCase(resetStateBetweenCallObjects.type, state => {
      state.meetingId = '';
      state.conferenceRecordId = '';
    });
  }
});
export const googleActions = google.actions;
export default google.reducer;